import { cn } from '../../lib/cn';

/**
 * DESIGN.md — Material Symbols Outlined, `name` is the ligature text (e.g.
 * `mail`, `key`, `shield`). Always `aria-hidden`: the icon is decoration,
 * never the only label for a control (Accessibility §8) — pair it with a
 * real `<label>`/button text/`aria-label` at the call site.
 */
export function Icon({ name, className }: { name: string; className?: string }) {
  return (
    <span aria-hidden className={cn('material-symbols-outlined leading-none', className)}>
      {name}
    </span>
  );
}
